import { render, staticRenderFns } from "./date.vue?vue&type=template&id=d5180ade&"
import script from "./date.vue?vue&type=script&lang=js&"
export * from "./date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports